import Button from './Button';

export interface TabConfig<T extends string = string> {
    id: T;
    label: string;
    icon: string;
}

interface TabNavigationProps<T extends string> {
    tabs: TabConfig<T>[];
    activeTab: T;
    onTabChange: (tab: T) => void;
}

export const TabNavigation = <T extends string>({ tabs, activeTab, onTabChange }: TabNavigationProps<T>) => {
    return (
        <div className="mb-6">
            <nav className="flex flex-wrap gap-2 md:gap-4">
                {tabs.map(tab => (
                    <Button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        variant={activeTab === tab.id ? 'tab-active' : 'tab'}
                        size="sm"
                        icon={<span className="mr-2">{tab.icon}</span>}
                        className="whitespace-nowrap"
                    >
                        {tab.label}
                    </Button>
                ))}
            </nav>
        </div>
    );
};

